// @flow
import {Store} from 'client/framework';
import type {ClassroomModelV1} from 'resources/augmented/Classroom/ClassroomModel.v1';
import {getResource, isResourcePopulated} from 'resources/mandark.resource';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import appStore from 'client/AppStore';

class SingleStudentStore extends Store {
  _getClassroomQuery(): Object {
    return mandarkEndpoint(['classrooms_v1', appStore.routerProps.params.classId])
      .include('students_v1')
      .done();
  }

  getClassroomData(): ClassroomModelV1 {
    return getResource(this._getClassroomQuery());
  }

  hasClassroomData(): boolean {
    return isResourcePopulated(this._getClassroomQuery());
  }
}

export default new SingleStudentStore('SingleStudentStore');
